import {combineReducers} from "redux";
import shows from './show.js';

const rootReducer= combineReducers({shows,});

export default rootReducer;